import styled from 'styled-components';

export const ProgressBar = styled.div`
    position: fixed;
    top: 0;
    z-index: 100;
`;